import { AppState } from '../../../store/App.reducer'
import { Message } from '../interface/message.interface'

export const selectMessage = (state: AppState): Message[] => state.messages.messages
